// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".opl-widget-preloader{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin:20px 15px 0 15px}.opl-widget-preloader--icon{padding-right:20px}.opl-widget-preloader--icon>*{width:40px;height:40px}.opl-widget-preloader--message p{line-height:1.29}", ""]);
// Exports
module.exports = exports;
